import {
  countriesInfo,
  CountryCode,
  defaultGeoLocationData,
} from '../countries';
import { getPhoneUtil } from '../getPhoneUtil';
import { isValidCountryCode } from '../isValidCountryCode';

export const getCountryCodeFromDialingCode = (
  dialingCode: string,
  fallBackCountryCode: CountryCode = defaultGeoLocationData.countryCode
) => {
  const foundValue = Object.values(countriesInfo).find(
    (info) => info.dialingCode === dialingCode
  );

  return (foundValue ?? countriesInfo[fallBackCountryCode]).code;
};

/**
 * Try to get the country code from a phoneNumber, even if it's still incomplete.
 */
export const getCountryCodeFromPhoneNumber = (
  phoneNumber: string | null | undefined,
  fallbackCountryCode: CountryCode = defaultGeoLocationData.countryCode
): CountryCode => {
  if (!phoneNumber) {
    return fallbackCountryCode;
  }

  try {
    const phoneUtil = getPhoneUtil();
    const number = phoneUtil.parse(phoneNumber);
    const countryCode = phoneUtil.getRegionCodeForNumber(number);

    return isValidCountryCode(countryCode) ? countryCode : fallbackCountryCode;
  } catch {
    return fallbackCountryCode;
  }
};
